{
  "actions": {
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "delete": "Delete",
    "remove": "Remove",
    "create": "Create",
    "edit": "Edit",
    "add": "Add",
    "new": "New",
    "newFem": "New",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "confirm": "Confirm",
    "search": "Search",
    "refresh": "Refresh",
    "retry": "Try again",
    "reset": "Reset",
    "submit": "Submit",
    "apply": "Apply",
    "duplicate": "Duplicate",
    "export": "Export",
    "import": "Import",
    "select": "Select",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "enable": "Enable",
    "disable": "Disable",
    "start": "Start",
    "stop": "Stop",
    "pause": "Pause",
    "resume": "Resume",
    "finish": "Finish",
    "skip": "Skip",
    "showMore": "Show more",
    "showLess": "Show less",
    "viewAll": "View all",
    "viewDetail": "View detail",
    "goBack": "Go back",
    "upload": "Upload",
    "download": "Download",
    "copy": "Copy",
    "filter": "Filter",
    "sort": "Sort",
    "configure": "Configure",
    "test": "Test",
    "calibrate": "Calibrate",
    "acknowledge": "Acknowledge",
    "resolve": "Resolve",
    "dismiss": "Dismiss"
  },
  "status": {
    "loading": "Loading data...",
    "loadingShort": "Loading...",
    "saving": "Saving...",
    "error": "Error",
    "success": "Success",
    "active": "Active",
    "inactive": "Inactive",
    "online": "Online",
    "offline": "Offline",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "pending": "Pending",
    "completed": "Completed",
    "failed": "Failed",
    "unknown": "Unknown",
    "noResults": "No results",
    "noData": "No data",
    "empty": "Empty",
    "healthy": "Healthy",
    "warning": "Warning",
    "critical": "Critical",
    "connected": "Connected",
    "disconnected": "Disconnected"
  },
  "confirm": {
    "deleteTitle": "Delete {{item}}?",
    "deleteDesc": "This action cannot be undone.",
    "unsavedChanges": "You have unsaved changes. Are you sure you want to leave?",
    "areYouSure": "Are you sure you want to continue?"
  },
  "labels": {
    "name": "Name",
    "description": "Description",
    "type": "Type",
    "status": "Status",
    "date": "Date",
    "from": "From",
    "to": "To",
    "notes": "Notes",
    "category": "Category",
    "priority": "Priority",
    "device": "Device",
    "sensor": "Sensor",
    "value": "Value",
    "unit": "Unit",
    "min": "Min",
    "max": "Max",
    "average": "Average",
    "total": "Total",
    "count": "Count",
    "duration": "Duration",
    "frequency": "Frequency",
    "interval": "Interval",
    "threshold": "Threshold",
    "limit": "Limit",
    "target": "Target",
    "current": "Current",
    "previous": "Previous",
    "details": "Details",
    "settings": "Settings",
    "actions": "Actions",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "lastTriggered": "Last triggered",
    "version": "Version",
    "size": "Size",
    "photo": "Photo",
    "photos": "Photos"
  },
  "time": {
    "hour": "hour",
    "hours": "hours",
    "day": "day",
    "days": "days",
    "week": "week",
    "weeks": "weeks",
    "month": "month",
    "months": "months",
    "minute": "minute",
    "minutes": "minutes",
    "second": "second",
    "seconds": "seconds",
    "hourly": "Hourly",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "now": "Now",
    "ago": "ago"
  },
  "errors": {
    "generic": "An unexpected error occurred.",
    "network": "Connection to server failed.",
    "notFound": "The requested record was not found.",
    "unauthorized": "You are not authorized to perform this action.",
    "validation": "Please check your input.",
    "loadFailed": "Failed to load data.",
    "saveFailed": "Failed to save changes.",
    "deleteFailed": "Failed to delete the record.",
    "tryAgain": "Please try again."
  },
  "preferences": {
    "appearanceAndLanguage": "Appearance & Language",
    "colorMode": "Color mode",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "System",
    "language": "Language",
    "timezone": "Timezone",
    "quietHours": "Do Not Disturb",
    "quietHoursDesc": "During this time you will not receive low or medium priority notifications. Critical alerts will still be delivered.",
    "advancedNotifications": "Advanced notification settings"
  },
  "nav": {
    "dashboard": "Dashboard",
    "myGarden": "My Garden",
    "growingAreas": "Growing Areas",
    "reservoirs": "Reservoirs",
    "batches": "Batches",
    "planning": "Planning",
    "cropPlans": "Crop Plans",
    "tasks": "Tasks",
    "scheduler": "Scheduler",
    "journal": "Journal",
    "library": "Library",
    "plantopedia": "Plant-O-Pedia",
    "recipes": "Recipes",
    "automation": "Automation",
    "rules": "Rules",
    "safety": "Safety Guards",
    "violations": "Violation History",
    "analytics": "Analytics",
    "settings": "Settings",
    "controls": "Controls",
    "dosing": "Nutrient Dosing",
    "sensors": "Sensors",
    "devices": "Devices",
    "profile": "Profile",
    "notifications": "Notifications",
    "help": "Help",
    "logout": "Log out",
    "more": "More",
    "monitoring": "Monitoring",
    "growing": "Growing",
    "calendar": "Calendar",
    "interlocks": "Interlocks",
    "interlockLog": "Protection Log",
    "interlockOverrides": "Admin Overrides",
    "service": "Service"
  },
  "validation": {
    "required": "This field is required.",
    "minLength": "Minimum {{min}} characters.",
    "maxLength": "Maximum {{max}} characters.",
    "invalidEmail": "Invalid email address.",
    "invalidNumber": "Please enter a valid number.",
    "minValue": "Minimum value is {{min}}.",
    "maxValue": "Maximum value is {{max}}.",
    "passwordMismatch": "Passwords do not match."
  },
  "pagination": {
    "page": "Page",
    "of": "of",
    "itemsPerPage": "Items per page",
    "showing": "Showing {{from}}-{{to}} of {{total}}",
    "first": "First",
    "last": "Last",
    "previous": "Previous",
    "next": "Next"
  },
  "not_specified": "Not specified"
}
